module.exports = __webpack_public_path__ + "static/media/textiles.6bbbc254.jpg";